module.exports = __webpack_public_path__ + "static/media/87.5ecefe38.png";